// 服务费计算
import { CalcWay, EffectType, EffectDiscountType, TAX_MODE } from '../../helper/const';

const calcServiceChargeMethod = ({ serviceCharge, peopleCount, originPrice }) => {
  const { calcWay, content } = serviceCharge;
  let prv = 0;

  switch (calcWay) {
    case CalcWay.DISCOUNT: // 占总价多少钱
      prv = (content / 100) * originPrice;
      break;
    case CalcWay.PEOPLE: // 人数
      prv = (peopleCount || 1) * content;
      break;
    case CalcWay.REGULAR: // 固定金额
      prv = content;
      break;
    default:
      break;
  }

  return prv;
};

// 服务费计算 整体方法
export const calcServiceCharge = ({ serviceCharge, beforeAndAfterPriv, peopleCount }) => {
  // 服务费, 优惠前计算
  if (serviceCharge && serviceCharge.beforePrivilegeCalc) {
    beforeAndAfterPriv.beforePrivServiceCharge = calcServiceChargeMethod({
      peopleCount,
      serviceCharge,
      originPrice: beforeAndAfterPriv.beforePrivTotal,
    });
  }

  // 服务费, 优惠后计算
  if (serviceCharge && !serviceCharge.beforePrivilegeCalc) {
    beforeAndAfterPriv.afterPrivServiceCharge = calcServiceChargeMethod({
      peopleCount,
      serviceCharge,
      originPrice: beforeAndAfterPriv.afterPrivTotal,
    });
  }

  return beforeAndAfterPriv;
};

// 服务费计算 整体方法
export const calcServiceChargeAll = ({ serviceCharge, beforeAndAfterPriv, peopleCount }) => {
  // 服务费, 优惠前计算
  // if (serviceCharge && serviceCharge.beforePrivilegeCalc) {
  beforeAndAfterPriv.beforePrivServiceCharge = calcServiceChargeMethod({
    peopleCount,
    serviceCharge,
    originPrice: beforeAndAfterPriv.beforePrivTotal,
  });
  // }

  // 服务费, 优惠后计算
  // if (serviceCharge && !serviceCharge.beforePrivilegeCalc) {
  beforeAndAfterPriv.afterPrivServiceCharge = calcServiceChargeMethod({
    peopleCount,
    serviceCharge,
    originPrice: beforeAndAfterPriv.afterPrivTotal,
  });
  // }

  return beforeAndAfterPriv;
};

// 消费税计算
// 消费税 优惠前 = 菜品总价 + 各种附加费; 优惠后 = 实际支付的钱
const calcExciseTaxChargeMethod = (consumptionTaxDTO, priv) => {
  const { taxRate = 0, effectType } = consumptionTaxDTO;

  if (effectType === EffectType.NOADD) {
    return 0;
  }

  const rate = taxRate / 100;

  return Math.max(priv * rate, 0);
};

export const calcExciseCharge = ({ joinTax, consumptionTaxDTO, beforeAndAfterPriv, initServiceCharge, lowestConsumptionCharge }) => {
  // 消费税, 优惠前
  if (consumptionTaxDTO && consumptionTaxDTO.discountType === EffectDiscountType.BEFORE) {
    // 服务费加入消费税计算
    if (joinTax) {
      beforeAndAfterPriv.beforePrivTotal += initServiceCharge;
    }

    return calcExciseTaxChargeMethod(consumptionTaxDTO, beforeAndAfterPriv.beforePrivTotal + lowestConsumptionCharge);
  }

  // 消费税, 优惠后
  if (consumptionTaxDTO && consumptionTaxDTO.discountType === EffectDiscountType.AFTER) {
    // 服务费加入消费税计算
    if (joinTax) {
      beforeAndAfterPriv.afterPrivTotal += initServiceCharge;
    }

    return calcExciseTaxChargeMethod(consumptionTaxDTO, beforeAndAfterPriv.afterPrivTotal + lowestConsumptionCharge);
  }
};

export const calcDishForTaxType = (priceForTax, taxes, taxInfo, taxMode) => {
  taxes.forEach(({ typeTaxCode, typeTaxName, rate }) => {
    const taxAmount = taxMode === TAX_MODE.INCLUDE ? priceForTax * (rate / (rate + 100)) : priceForTax * rate / 100;
    if (taxInfo[typeTaxName]) {
      taxInfo[typeTaxName].amount += taxAmount;
    } else {
      taxInfo[typeTaxName] = {
        typeTaxName,
        typeTaxCode,
        amount: taxAmount,
      };
    }
  });

  return taxInfo;
};



// WEBPACK FOOTER //
// ./src/helper/privilege/service-charge-calc.js